import { render, staticRenderFns } from "./status-bar-ag-grid.vue?vue&type=template&id=82254586"
import script from "./status-bar-ag-grid.vue?vue&type=script&lang=js"
export * from "./status-bar-ag-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports